import { useEffect, useRef, type ReactNode } from 'react';

/**
 * O corpo das janelas da campanha CPTu (Nova campanha, Cancelar a campanha,
 * Cabeçalho da vertical) como formulário — agent-browser da 312.
 *
 * Duas coisas que a janela da casa (`Dialogo`, `ui.tsx`) não faz, e que aqui
 * não mudam a casa:
 *
 *  · o Enter no campo de uma linha grava (`<form onSubmit>`, e o botão
 *    principal é o `type="submit"`). O `aoEnviar` confere o que falta, como
 *    o clique. No campo de texto longo o Enter quebra a linha — e no motivo
 *    de cancelar, só o botão cancela (P-UI-28, rodada final da 312);
 *  · a janela abre com o foco no primeiro campo, e não no «×». O
 *    `showModal()` do `<dialog>` põe o foco no primeiro descendente com o
 *    ATRIBUTO `autofocus` — e o React não escreve esse atributo (o `autoFocus`
 *    dele chama `focus()` ao montar, quando o `<dialog>` ainda está fechado).
 *    O efeito daqui roda antes do da janela (o filho antes do pai), marca o
 *    primeiro campo livre, e o `showModal()` o acha.
 *
 * O formulário é o último filho do corpo da janela: o rodapé de botões dentro
 * dele segue o desenho Carbon (as regras da 277 contam com `form:last-child`).
 */
export function FormularioDaJanela({ aoEnviar, children }: { aoEnviar(): void; children: ReactNode }) {
  const ref = useRef<HTMLFormElement>(null);
  useEffect(() => {
    const campo = ref.current?.querySelector<HTMLElement>(
      'input:not([type="hidden"]):not(:disabled), select:not(:disabled), textarea:not(:disabled)');
    campo?.setAttribute('autofocus', '');
  }, []);
  return (
    <form ref={ref} className="cptu-formulario-da-janela" noValidate
      onSubmit={(e) => { e.preventDefault(); aoEnviar(); }}>
      {children}
    </form>
  );
}
